import { Box, Container, Stack, Typography } from '@mui/material'
import { CTAButtons } from './CTAButtons'

export function Section6() {
  return (
    <Container
      component={Box}
      py={8}
    >
      <Stack
        spacing={6}
        alignItems='center'
      >
        <Typography
          component='h2'
          variant='next:h2'
          fontWeight={700}
          textAlign='center'
        >
          Mapstack: effortless location insights
        </Typography>
        <Typography
          component='p'
          variant='next:h6'
          color='text.secondary'
          textAlign='center'
          maxWidth='80ch'
        >
          Mapstack instantly transforms your messy user data into actionable,
          interactive maps—no technical skills required. Quickly find, filter,
          and export the exact segments you need, all without juggling multiple
          tools.
        </Typography>

        <CTAButtons />
      </Stack>
    </Container>
  )
}
